import { SpynlBase } from '@shared/app/scripts/services/spynl-base';
import { Injectable } from 'angular-ts-decorators';

import { Domain } from './domain';
import { TransitModel } from '../classes/transit-model';
import type { IConfig } from './config';
import type { IStandardErrorParser } from './standard-error-parser';

/**
 * Simple service to take care of communicating with new /transits/add endpoint
 */
@Injectable('transit')
export class Transit extends SpynlBase<TransitModel> {
  constructor(
    protected $http: ng.IHttpService,
    protected $q: ng.IQService,
    protected sentry,
    protected domain: Domain,
    protected config: IConfig,
    protected standardErrorParser: IStandardErrorParser,
  ) {
    'ngInject';
    super($http, $q, sentry, domain, config, standardErrorParser, TransitModel);
    this.location = '/transits';
  }

  /**
   * @param {string} _id
   * the id of the transit order
   * @param {string[]} recipients
   * the array of recipient emails
   * Sends a transit order as PDF email using /transits/email
   * @returns {promise}
   * resolve with response on success, otherwise reject with the error
   */
  email(_id: string, recipients: string[]): ng.IPromise<any> {
    return this.$http
      .post(
        `${this.domain.getSpynl()}${this.location}/email`,
        { _id, recipients },
        {
          // done on config level for v7; setting for v6
          withCredentials: true,
        },
      )
      .then((response: any) => response.data.status);
  }

  /**
   * @returns {promise}
   * Resolve with response on success, otherwise reject with the error
   */
  startNew(): ng.IPromise<{}> {
    return this.$http
      .post(
        this.domain.getSpynl() + '/transits/start-new',
        {},
        {
          // done on config level for v7; setting for v6
          withCredentials: true,
        },
      )
      .then((response: any) => response.data.data);
  }
}
